import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sun, Moon, Eye, EyeOff } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import '../pages/Login.css';

// The sign-in page's card, shared by the pages an emailed link opens
// (forgot password, reset password, accept invite, verify email).
export function AuthCard({ subtitle, children }) {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="login-container">
      <button className="btn-icon login-theme-toggle" onClick={toggleTheme} aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
        {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
      </button>

      <div className="login-card">
        <div className="login-header">
          <Link to="/" className="login-title-link"><h1 className="login-title">ActiveOptics</h1></Link>
          {subtitle && <p className="login-subtitle">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}

// A password input with the show/hide toggle the sign-in page uses.
export function PasswordField({ id, label, value, onChange, placeholder, autoComplete = 'new-password', describedBy }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="form-group">
      <label className="form-label" htmlFor={id}>{label}</label>
      <div className="password-field">
        <input
          id={id}
          type={shown ? 'text' : 'password'}
          className="form-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required
          aria-required="true"
          autoComplete={autoComplete}
          aria-describedby={describedBy}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShown((v) => !v)}
          aria-label={shown ? 'Hide password' : 'Show password'}
          aria-pressed={shown}
          tabIndex={-1}
        >
          {shown ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    </div>
  );
}

export default AuthCard;
